import { Input } from 'antd';
import './index.less';
export default Input;
